@if (isVisible) {
  <div class="dialog-overlay" (click)="closeDialog()" (keydown.escape)="closeDialog()">
    <div class="dialog-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <h3 class="dialog-title">{{ 'DELETE_SPACE.TITLE' | translate }}</h3>
      <p class="dialog-description">
        {{ 'DELETE_SPACE.CONFIRM_TEXT_START' | translate }} <span class="space-name">"{{ spaceName }}"</span>{{ 'DELETE_SPACE.CONFIRM_TEXT_END' | translate }}
      </p>
      <div class="dialog-actions">
        <button class="btn-cancel" (click)="closeDialog()">{{ 'DELETE_SPACE.CANCEL' | translate }}</button>
        <button class="btn-delete" (click)="confirmDelete()">{{ 'DELETE_SPACE.CONFIRM' | translate }}</button>
      </div>
    </div>
  </div>
}
